import { assert, isDefined } from '@sama/js-core';
import { forEach, isUndefined } from 'lodash';
import { ShapeState } from '../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { strictValues } from '../../../../../cross-team-shared/misc-utils/strict-record';
import { DeleteShapeOperation } from '../../../../../team-apis/otterdam/annotation-operations/shape-operations';
import { Output } from '../../../../../team-apis/otterdam/outputs/output';
import { DeleteShapeLocationOperationBuilder } from './delete-shape-location-operation-builder';
import { ShapeOperationBuilderParams } from './shape-operation-builder-params';

export function createDeleteShapeOperationBuilders(
  params: ShapeOperationBuilderParams,
) {
  const { previousShape, currentShape, output } = params;
  let deleteLocationBuilders: DeleteShapeLocationOperationBuilder[] = [];

  if (previousShape && !currentShape) {
    const frameNumbersToDelete = new Set<number>();
    forEach(previousShape.key_locations, (location) => {
      frameNumbersToDelete.add(location.frame_number);
    });
    forEach(strictValues(previousShape.dynamic_tags), (dynamic_tag) => {
      forEach(dynamic_tag, (location) => {
        frameNumbersToDelete.add(location.frame_number);
      });
    });

    deleteLocationBuilders = Array.from(frameNumbersToDelete).map(
      (frameNumber) =>
        new DeleteShapeLocationOperationBuilder(
          frameNumber,
          output,
          previousShape,
        ),
    );
  }

  return [...deleteLocationBuilders, new DeleteShapeOperationBuilder(params)];
}

export class DeleteShapeOperationBuilder {
  private currentShape?: ShapeState;
  private previousShape?: ShapeState;
  private output: Output;

  constructor({
    currentShape,
    previousShape,
    output,
  }: ShapeOperationBuilderParams) {
    this.currentShape = currentShape;
    this.previousShape = previousShape;
    this.output = output;
  }

  canBuild() {
    return isUndefined(this.currentShape) && isDefined(this.previousShape);
  }

  build(): DeleteShapeOperation {
    assert(
      this.previousShape,
      'previous shape should be defined for shape deletion',
    );
    return buildDeleteShapeOperation(this.previousShape.index, this.output.id);
  }
}

export function buildDeleteShapeOperation(
  shapeId: number,
  outputId: number,
): DeleteShapeOperation {
  return { operation: 'DELETE_SHAPE', ids: { shapeId }, outputId };
}
